import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { AdminImage } from '../../services/api-services/admin-images.service';

export interface EditProductModalData {
  product: AdminImage;
  title?: string;
}

export interface EditProductModalResult {
  brand: string;
  item: string;
  material: string;
  color: string;
  price: number;
  age: string;
  condition: string;
}

@Component({
  selector: 'app-edit-product-modal',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSelectModule
  ],
  templateUrl: './edit-product-modal.component.html',
  styleUrl: './edit-product-modal.component.scss'
})
export class EditProductModalComponent {
  form: FormGroup;

  readonly conditionOptions = ['Excellent', 'Good', 'Fair', 'Flawed'];
  readonly ageOptions = ['Current', 'Off-Trend', 'Vintage'];

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<EditProductModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditProductModalData
  ) {
    const p = data.product;
    this.form = this.fb.group({
      brand:     [p.brand     ?? '',   Validators.required],
      item:      [p.item      ?? '',   Validators.required],
      material:  [p.material  ?? ''],
      color:     [p.color     ?? ''],
      price:     [p.price     ?? null, [Validators.min(0)]],
      age:       [p.product_age       ?? ''],
      condition: [p.product_condition ?? '']
    });
  }

  get title(): string {
    return this.data.title ?? 'Edit Product';
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const v = this.form.value;
    const result: EditProductModalResult = {
      brand:     (v.brand     ?? '').trim(),
      item:      (v.item      ?? '').trim(),
      material:  (v.material  ?? '').trim(),
      color:     (v.color     ?? '').trim(),
      price:     v.price !== null && v.price !== '' ? Number(v.price) : 0,
      age:       (v.age       ?? '').trim(),
      condition: (v.condition ?? '').trim()
    };
    this.dialogRef.close(result);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
